import Bank from "./modules/BankVuex";
import Client from "./modules/ClientVuex"
import Employee from "./modules/EmployeeVuex";
import Deal from "./modules/DealVuex";
import Modality from "./modules/ModalityVuex.js";
import Financial from "./modules/FinancialVuex";
import PaymentOption from "./modules/PaymentOptionVuex"
import Prospect from "./modules/ProspectVuex";
import Supplier from './modules/SupplierVuex'
import Company from './modules/CompanyVuex'
import EmployeeRole from "./modules/EmployeeRoleVuex";
import Driver from "./modules/DriverVuex";
import Truck from "./modules/TruckVuex";
import BankAccount from "./modules/BankAccountVuex.js";
import ClientPortfolio from "./modules/ClientPortfolioVuex.js";

export default {
  Bank,
  Client,
  Employee,
  Financial,
  Deal,
  Modality,
  PaymentOption,
  Prospect,
  Supplier,
  Company,
  EmployeeRole,
  Driver,
  Truck,
  BankAccount,
  ClientPortfolio
}